<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import AppLayout from '@/layouts/AppLayout.vue'
import PublicLayout from '@/layouts/PublicLayout.vue'

const route = useRoute()

// The console shell by default; the public site gets its own header and footer;
// the OIDC callback and the "no role" screens render bare, because there is no
// user to show a menu to.
const layout = computed(() => route.meta.layout ?? 'console')
</script>

<template>
  <AppLayout v-if="layout === 'console'">
    <RouterView />
  </AppLayout>
  <PublicLayout v-else-if="layout === 'public'">
    <RouterView />
  </PublicLayout>
  <RouterView v-else />

  <Toast />
  <ConfirmDialog />
</template>
